import { ApiAuthProvider } from "./api-auth";
import React from "react";

type AppProviderProps = { children: React.ReactNode };

function AppProvider({ children }: AppProviderProps) {
  return <ApiAuthProvider>{children}</ApiAuthProvider>;
}

export default AppProvider;
